import _default from './Responsive';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/addons/Responsive/index.js
// module id = 933
// module chunks = 0